export const MANAGE_ACCESS_REQUESTS_PAGE_TITLE = 'MANAGE_ACCESS_REQUESTS:ADVERTISER_INVITES:FOCUS_VIEW:TITLE'
export const MANAGE_ACCESS_REQUESTS_BACK_TO_ACCOUNTS = 'MANAGE_ACCESS_REQUESTS:ADVERTISER_INVITES:BACK_TO_ACCOUNTS'
export const MANAGER_ACCESS_REQUESTS_CARD_HEADER = 'MANAGE_ACCESS_REQUESTS:ADVERTISER_INVITES:CARD_HEADER'
export const MANAGER_ACCESS_REQUESTS_WITHDRAW_SUCCESS_ALERT = 'MANAGE_ACCESS_REQUESTS:ADVERTISER_INVITES:WITHDRAW_SUCCESS_ALERT'
